import Head from 'next/head'
import { MainLayout } from '@/layouts'

const ContactUs = () => {
  return (
    <MainLayout noPaddingTop footerTheme="light" footerSticky={false}>
      <Head>
        <title>Contact Us | Chacra Software Solutions</title>
      </Head>
    </MainLayout>
  )
}

export default ContactUs
